"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var aftersaleApi = _interopRequireWildcard(require("@/api/aftersaleApi.js"));
var _validate = require("@/utils/validate");
var cache;
function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {},
  data: function data() {
    return {
      loading: false,
      visible: false,
      detailInfo: {},
      handerOptions: [],
      checkboxGroup: [],
      pram: {
        auditStatus: 1
      }
    };
  },
  mounted: function mounted() {
    this.checkboxGroup = [];
  },
  methods: {
    initOpen: function initOpen() {
      var detailInfo = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.detailInfo = detailInfo;
      this.visible = true;
    },
    handerSubmit: (0, _validate.Debounce)(function (form) {
      var _this = this;
      this.$refs[form].validate(function (valid) {
        if (!valid) return;
        _this.loading = true;
        var _ref = _this.pram || {},
          description = _ref.description,
          auditStatus = _ref.auditStatus;
        aftersaleApi.auditFinancePending({
          aftersaleId: _this.detailInfo.id,
          description: description,
          auditStatus: auditStatus
        }).then(function (data) {
          _this.$message.success('操作成功');
          _this.loading = false;
          _this.visible = false;
          _this.$emit('doRefresh');
        }).catch(function () {
          _this.loading = false;
        });
      });
    }),
    closeEdit: function closeEdit() {
      this.visible = false;
    }
  }
};